import styles from './styles.module.scss'
import { Swiper, SwiperSlide } from 'swiper/react'

import { Autoplay } from 'swiper/modules'
import SwiperCore from 'swiper'

import CakeIcon from './icons/cake.png'
import ChangeNowIcon from './icons/changenow.png'
import CryptoIcon from './icons/crypto.png'
import GuardaIcon from './icons/guarda.png'
import GurdarianIcon from './icons/gurda.png'
import HackIcon from './icons/hack.png'
import KoinlyIcon from './icons/koinly.png'
import MetaverseIcon from './icons/metaverse.png'
import SumsubIcon from './icons/sumsub.png'
import { useTranslation } from 'utils/use-translation'
import { HTMLAttributes, useEffect, useRef } from 'react'

import Image from 'next/image'
import useViewport from 'libs/use-viewport'

const data = [
  {
    icon: CryptoIcon,
    href: 'https://cryptorealestate.cc/',
  }, {
    icon: KoinlyIcon,
    href: 'https://koinly.io/',
  }, {
    icon: MetaverseIcon,
    href: 'https://mpost.io/',
  }, {
    icon: CakeIcon,
    href: 'https://cakewallet.com/'
  }, {
    icon: GuardaIcon,
    href: 'https://guarda.com/',
  }, {
    icon: SumsubIcon,
    href: 'https://sumsub.com/',
  }, {
    icon: ChangeNowIcon,
    href: 'https://changenow.io/',
  }, {
    icon: HackIcon,
    href: 'https://hackseasons.com/',
  }, {
    icon: GurdarianIcon,
    href: 'https://cakewallet.com/',
  },
]

interface OurPartnersProps extends HTMLAttributes<HTMLDivElement> { }

const OurPartners = ({ className }: OurPartnersProps) => {
  const { t } = useTranslation()
  const view = useViewport()
  const isMobile = view.includes('xs-mobile') || view.includes('mobile')

  const swiperAutoPlay = useRef(null)
  const swiperRef = useRef<SwiperCore | null>(null)

  SwiperCore.use([Autoplay])

  useEffect(() => {
    if (swiperAutoPlay.current) {
      const swiper = swiperRef.current

      swiper.autoplay.start()
    }
  }, [])

  return (
    <section className={className}>
      <h2 className={styles.section__title}>{t('our_partners')}</h2>

      <Swiper
        className={styles.slides}
        spaceBetween={isMobile ? 40 : 60}
        grabCursor={true}
        slidesPerView={'auto'}
        loop={true}
        speed={4000}
        autoplay={{ delay: 0, disableOnInteraction: false }}
        ref={swiperAutoPlay}
        onSwiper={(swiper) => {
          swiperRef.current = swiper
        }}
        modules={[Autoplay]}
        freeMode={true}
      >
        {[...data, ...data, ...data].map(({ icon, href }, index) => (
          <SwiperSlide key={index} className={styles.slide}>
            <a href={href} target="_blank" rel="noreferrer">
              <Image
                className={styles.slide__img}
                src={icon}
                alt={'partner-icon'}
                width={100}
                height={100} />
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  )
}

export default OurPartners
